import script from "./RightTool.vue?vue&type=script&setup=true&lang=js"
export * from "./RightTool.vue?vue&type=script&setup=true&lang=js"

import "./RightTool.vue?vue&type=style&index=0&id=6d60e912&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d60e912"]])

export default __exports__